export function replace(target, name, value) {
  return Object.assign(
    {},
    target,
    { [name]: target[name].replace('#replace#', value) },
  )
}
export function replaceSkin(target, name) {
  return Object.assign(
    {},
    target,
    { [name]: target[name] },
  )
}

export function create(...rest) {
  return Object.assign(Object.create(null), ...rest)
}
